exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np.error-text[data-v-ee26bf32]{\n  display: inline;\n}\n.artist-not-exist[data-v-ee26bf32] {\n  margin-top: 50px;\n}\n.vocaloid-notice[data-v-ee26bf32] {\n  margin: 8px auto 25px 0;\n  display: block;\n  font-size: 1.4rem;\n}\n", ""]);

// exports
